import { useQuery } from '@tanstack/react-query';
import {
  fetchOccupationCatalog,
  type OccupationCatalogResponse,
  searchOccupations,
  type OccupationSearchResult,
} from '../api/occupations';

export function useOccupationSearch(query: string) {
  const trimmed = query.trim();
  const enabled = trimmed.length >= 2;

  return useQuery<OccupationSearchResult[], Error>({
    queryKey: ['occupations', trimmed],
    queryFn: () => searchOccupations(trimmed),
    enabled,
    staleTime: 1000 * 60 * 60,
  });
}

export function useOccupationCatalog(query?: string) {
  const trimmed = query?.trim() ?? '';

  return useQuery<OccupationCatalogResponse, Error>({
    queryKey: ['occupation-catalog', trimmed],
    queryFn: () => fetchOccupationCatalog(trimmed || undefined),
    staleTime: 1000 * 60 * 60 * 24,
  });
}
